/// <amd-module name="Search/Wiki/Components/PivotCommands" />

import * as SharedResources from "Search/Shared/Resources";
import { ActionCreator } from "Search/Wiki/Flux/ActionCreator";
import { IAggregatedState } from "Search/Wiki/Flux/StoresHub";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar"
import { IPivotCommands } from "Search/Shared/Components/PivotCommands";
import { ObservableValue } from "VSS/Core/Observable";

export function handlePivotCommands(
    pivotCommands: ObservableValue<IPivotCommands>,
    getAggregatedState: () => IAggregatedState,
    actionCreator: ActionCreator,
    isMember: boolean,
    isOrgButtonEnabled: boolean): void {
    const {
        isProjectContext,
        filterStoreState
    } = getAggregatedState();
    const {
        clickAccountButton,
        toggleFilterPane
    } = actionCreator;

    const { filter, filterItemsVisible } = filterStoreState;
    const toggleButtonTooltip = filterItemsVisible ? SharedResources.HideFilterPanel : SharedResources.ShowFilterPanel;
    const filterToggle: IHeaderCommandBarItem = {
        id: "filterToggle",
        ariaLabel: toggleButtonTooltip,
        subtle: true,
        tooltipProps: { text: toggleButtonTooltip },
        iconProps: { iconName: filter.hasChangesToReset() ? "FilterSolid" : "Filter" },
        onActivate: item => toggleFilterPane()
    }

    const showSearchThisAccountButton = isMember && isProjectContext;

    const items: IHeaderCommandBarItem[] = [];
    if (showSearchThisAccountButton) {
        items.push(
            {
                subtle: true,
                text: SharedResources.SearchThisAccountButtonText,
                id: "searchAccountLink",
                iconProps: { iconName: "ReplyMirrored" },
                onActivate: item => clickAccountButton()
            });
    }

    pivotCommands.value = { farItems: [filterToggle], items };
}